export enum DataBoundary {
  // Rest of world
  ROW = 0,
  // EUDB
  EU = 1,
}

export const DataBoundaryValues: { [key: number]: string[] } = {
  [DataBoundary.ROW]: ['NONE'],
  [DataBoundary.EU]: ['EUDB', 'EU'],
};
